<template>
  <div class="warp">
    <div :class="{ mobile: isMobile, pc: !isMobile }">
      <component
        @scrollIntoView="scrollIntoView"
        :loagImageFlex="loagImageFlex"
        id="Activity01"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        class="Activity01"
        :is="'Activity01'"
      ></component>
      <component
        @yySuccess="yySuccess"
        @yyEarry="yyEarry"
        @scrollIntoView="scrollIntoView"
        :newAreatype="areatype"
        :newPhone1="newPhone"
        id="Activity02"
        class="Activity02"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity02'"
      ></component>
      <component
        @scrollIntoView="scrollIntoView"
        id="Activity03"
        class="Activity03"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity03'"
      ></component>
      <component
        @scrollIntoView="scrollIntoView"
        id="Activity04"
        class="Activity04"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity04'"
      ></component>
      <component
        @scrollIntoView="scrollIntoView"
        id="Activity05"
        class="Activity05"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity05'"
      ></component>
      <component
        @scrollIntoView="scrollIntoView"
        id="Activity06"
        class="Activity06"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity06'"
      ></component>
      <component
        @scrollIntoView="scrollIntoView"
        id="Activity07"
        class="Activity07"
        @getStatus="getStatus"
        @showPhoneHandel="showPhoneHandel"
        @showShowCheck="showShowCheck"
        :footerIsShow="footerIsShow"
        :is="'Activity07'"
      ></component>
      <!-- <component
        :is="'FaceDialog'"
        :visible="visible"
        :page="page"
        @isActivity="isActivity"
        @getStatus="getStatus"
        @changePage="changePage"
        @showPhoneHandel="showPhoneHandel"
        @changeVisible="changeVisible"
        @changeBackgroundImage="changeBackgroundImage"
        @showShowCheck="showShowCheck"
        :backgroundImage="backgroundImage"
        @scrollIntoView="scrollIntoView"
        @setPhone="setPhone"
        @setAreatype="setAreatype"
      ></component> -->
      <SimpleDialog
        :backgroundImage="require('../../../public/image/12/8/1.png')"
        :removeImage="require('../../../public/image/12/8/3.png')"
        :textImage="require('../../../public/image/12/8/2.png')"
        :visible.sync="showPhone"
        @changeVisible="showPhone = !showPhone"
      />
      <CheckDialog
        :backgroundImage="require('../../../public/image/12/4/4.png')"
        :removeImage="require('../../../public/image/12/6/3.png')"
        :textImage="require('../../../public/image/12/10/1.png')"
        :textImage1="require('../../../public/image/12/10/2.png')"
        @scrollIntoView="scrollIntoView"
        :visible.sync="showCheck"
        @changeVisible="showCheck = !showCheck"
      />
    </div>
  </div>
</template>

<script>
import getData from '../../../utils/request/request'
import SimpleDialog from './components/simpleDialog/index.vue'
import CheckDialog from './components/checkGameDialog/index.vue'
import isMobile from '../../../utils/isMobile.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    SimpleDialog,
    CheckDialog
  },
  data() {
    return {
      isActivity: false,
      page: 1,
      isMobile: isMobile(),
      backgroundImage: '',
      footerIsShow: false,
      showPhone: false,
      visible: false,
      showCheck: false,
      loagImageFlex: false,
      newPhone: '',
      areatype: 0,
      count: 0,
      timeFn: null
    }
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  mounted() {
    this.preload()
    window.addEventListener('scroll', this.listenerScroll, true)
    const body = document.getElementsByTagName('body')[0]
    const html = document.getElementsByTagName('html')[0]
    body.style.background = `url(${require('../../../public/image/2.png')}) no-repeat`
    body.style.backgroundSize = '100% 100%'
    body.style.overflowY = 'auto'
    html.style.overflowY = 'auto'
  },
  async created() {
    if (this.phone) {
      await this.getStatus()
      if (!this.gameStatus.loginstatus) {
        this.page = 1
        this.visible = true
        this.isActivity = false
      }
    } else {
      this.page = 1
      this.visible = true
      this.isActivity = false
    }
    await this.getStatus()
  },
  watch: {
    visible(val) {
      if (!val) {
        if (!this.gameStatus.loginstatus) {
          clearTimeout(this.timeFn)
          let _this = this
          this.timeFn = setTimeout(() => {
            _this.page = 1
            _this.visible = true
          }, 5000)
        }
      } else {
        clearTimeout(this.timeFn)
        this.timeFn = null
      }
    }
  },
  methods: {
    yySuccess() {
      clearTimeout(this.timeFn)
      this.timeFn = null
      this.page = 2
      this.visible = true
      this.isActivity = true
    },
    yyEarry() {
      clearTimeout(this.timeFn)
      this.timeFn = null
      this.page = 1
      this.visible = true
    },
    preload() {
      let imgs = [require('../../../public/image/1.gif')]
      for (let img of imgs) {
        let image = new Image()
        image.src = img
        image.onload = () => {
          this.count++
        }
      }
    },
    showShowCheck() {
      this.showCheck = true
    },
    showPhoneHandel() {
      this.showPhone = true
    },
    setPhone(phone) {
      this.newPhone = phone
    },
    setAreatype(areatype) {
      this.areatype = areatype
    },
    async getStatus() {
      let Api = {
        url: '/api/get_status',
        type: 'post'
      }
      let form = {
        phone: this.phone
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        let data = {
          loginstatus: res.loginstatus,
          people: res.people,
          count: res.count,
          yuyuestatus: res.yuyuestatus,
          shopstatus: res.shopstatus,
          fbazstatus: res.fbazstatus,
          fbststatus: res.fbststatus,
          zystatus: res.zystatus,
          slmstatus: res.slmstatus
        }
        this.$store.commit('changeGameStatus', data)
      }
    },
    changeBackgroundImage(val) {
      this.backgroundImage = val
    },
    changeVisible(val) {
      this.visible = val
    },
    changePage(val) {
      this.page = val
    },
    scrollIntoView(el) {
      document.querySelector(el).scrollIntoView()
    },
    checkInViewport() {
      const myElement = document.getElementById('setp1warp')
      const rect = myElement.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      let contentTop
      let contentBottom
      if (rect.top >= 0 && rect.top <= viewportHeight) {
        contentTop = true
      } else {
        contentTop = false
      }
      if (rect.bottom >= 0 && rect.bottom <= viewportHeight) {
        contentBottom = true
      } else {
        contentBottom = false
      }
      return contentTop || contentBottom
    },
    listenerScroll() {
      let value =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let clientHeight
      if (this.isMobile) {
        clientHeight = (window.innerWidth / 375) * 628
      } else {
        clientHeight = ((window.innerWidth * 8) / 15 / 375) * 628
      }
      if (value >= clientHeight) {
        this.footerIsShow = true
        this.loagImageFlex = true
      } else {
        this.footerIsShow = false
        this.loagImageFlex = false
      }
      if (!this.gameStatus.loginstatus) {
        if (this.checkInViewport()) {
          clearTimeout(this.timeFn)
          this.timeFn = null
        } else if (!this.timeFn) {
          let _this = this
          this.timeFn = setTimeout(() => {
            _this.page = 1
            _this.visible = true
            _this.isActivity = false
          }, 5000)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.scrollable {
  scroll-behavior: smooth;
}
// body {

// }
</style>

<style lang="scss" scoped>
// /deep/ body {
//   background: url(../../../public/image/2.png) no-repeat;
//   background-size: 100% 100%;
// }
.warp {
  // height: 100vh;
  width: 100%;
  .pc {
    max-width: calc(8 / 15 * 100vh);
    margin: 0 auto;
    // overflow: auto;
    // height: 100vh;
    // overflow: auto;
  }
  .mobile {
    width: 100%;
    // overflow: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/index.vue